function isMobile() {
    return window.matchMedia( "( max-width: 1439px )" ).matches;
}

export default () => ({
    currentPanel: null,
    Panels: null,
    isReady: false,
    showCodeCopyToast: false,

    copyToClipboard( text ) {
        // console.log("Alpine copyToClipboard", {
        //     text,
        //     navigator: navigator.clipboard
        // });
        if (navigator.clipboard) {
            navigator.clipboard.writeText( text )
                .then(() => {
                    console.log('Copied!');
                    this.showCodeCopyToast = true;
                })
                .catch(err => console.error('Failed to copy:', err));
        } else {
            alert('Clipboard not supported');
        }
    },

    onClickCloseCopyToClipBoardToast() {
        this.showCodeCopyToast = false;
    }
    //
    // init() {
    //     console.log( 'Account Management UI' );
    // }

})
